<img [width]="width" [src]="icon()" [alt]="name" />
